<template>
  <main class="create-job-post-view d-flex flex-column h-100 w-100 bg-bgDefault">
    <Transition
      name="step-fade"
      mode="out-in"
    >
      <CreateJobPostStep1
        v-if="store.step === 1"
        key="step1"
      />
      <CreateJobPostStep2
        v-else-if="store.step === 2"
        key="step2"
      />
    </Transition>
  </main>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useCreateJobPostWizard } from '@/stores/jobPosts/createJobPostWizard';
import CreateJobPostStep1 from '@/components/jobPosts/wizard/CreateJobPostStep1.vue';
import CreateJobPostStep2 from '@/components/jobPosts/wizard/CreateJobPostStep2.vue';

const route = useRoute();
const store = useCreateJobPostWizard();

onMounted(() => {
  const { 'job-code': jobCode, title, location } = route.query;

  if (jobCode) store.formJobCode = jobCode;
  if (title) store.formTitle = title;
  if (location) store.formLocation = location;
});

onUnmounted(() => {
  store.reset();
});
</script>

<style scoped>
.step-fade-enter-active,
.step-fade-leave-active {
  transition: opacity 0.15s ease;
}

.step-fade-enter-from,
.step-fade-leave-to {
  opacity: 0;
}
</style>
